<template>
  <div class="container-xl">
    <div class="hade">
      <router-link to="/about"
        ><img
          src="../img/button icon@2x2.png"
          alt=""
        />&nbsp;预约口腔扫描</router-link
      >
    </div>
    <div class="row">
      <div class="time">
        <h3>口腔扫描预约</h3>
        <h5>
          日期&nbsp;&nbsp;
          <span style="color: #323e48">{{ time.date }}</span>
        </h5>
        <h5>
          时段&nbsp;&nbsp;
          <span style="color: #323e48"
            ><span v-if="time.start < 12">
              上午{{ Math.floor(time.start / 2) }}:{{
                Number(time.start) % 2 == 0 ? "00" : "30"
              }}-上午{{ Math.ceil(time.start / 2) }}:{{
                Number(time.start) % 2 == 0 ? "30" : "00"
              }}
            </span>
            <span v-if="time.start > 12">
              下午 {{ Math.floor(time.start / 2) }}:{{
                Number(time.start) % 2 == 0 ? "00" : "30"
              }}-下午{{ Math.ceil(time.start / 2) }}:{{
                Number(time.start) % 2 == 0 ? "30" : "00"
              }}
            </span></span
          >
        </h5>
      </div>
      <div class="clinic">
        <h4>{{ city.name }}</h4>
        <p>就诊时间 : {{ city.BH }}</p>
        <p>联系电话 : {{ city.phone }}</p>
        <p>地址 : {{ city.address }}</p>
      </div>
      <div class="data">
        <h5>
          姓名&nbsp;&nbsp;<span style="color: #323e48">{{
            liaison.userName
          }}</span>
        </h5>
        <h5>
          手机&nbsp;&nbsp;<span style="color: #323e48">{{
            liaison.userPhone
          }}</span>
        </h5>
        <!--        <h5>-->
        <!--          邮箱&nbsp;&nbsp;<span style="color: #323e48">{{ liaison.mail }}</span>-->
        <!--        </h5>-->
        <p>
          检查流程需要大约1小时，包括口腔扫描、结果分析及专家建议。
          请提前10分钟到达，以便尽快开始检查。
        </p>
        <h3>完成口腔扫描后，你将在3天内收到量身定制的矫正计画</h3>
        <div class="botttom">
          <button style="cursor: pointer" @click="kap1()">确认并预约</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { confirmAppointmentClinic } from "@/api/outpatient";
export default {
  metaInfo: {
    link: [
      {
        rel: "canonical",
        href: "https://mybeame.com/complete",
      },
      {
        rel: "alternate",
        href: "https://mybeame.com/complete",
        hrefLang: "x-default",
      },
    ],
  },

  data() {
    return {
      city: [{}],
      liaison: [{}],
      time: [{}],
      fbqEventId: new Date().getTime(),
    };
  },
  mounted() {
    this.liaison = JSON.parse(localStorage.getItem("liaison")); //获取本地数据
    this.city = JSON.parse(localStorage.getItem("city"));
    this.time = JSON.parse(localStorage.getItem("time"));
  },
  methods: {
    //转换时间
    GetHb: function (e) {
      var time = e.appointmentStart;
      var bh = "";
      if (time % 2 == 0) {
        bh = parseInt(time / 2) + ":00";
      } else {
        bh = parseInt(time / 2) + ":30";
      }
      time = e.appointmentEnd;
      if (time % 2 == 0) {
        bh += "-" + parseInt(time / 2) + ":00";
      } else {
        bh += "-" + parseInt(time / 2) + ":30";
      }
      e["BH"] = bh;
      var count = parseInt((e.appointmentEnd - e.appointmentStart) / 2);
      e["TimeCount"] =
        (e.appointmentEnd - e.appointmentStart) % 2 == 0 ? count : count + 1;
      return bh;
    },

    //预约事件
    kap1() {
      var uresData = {
        appointmentTime: this.time.date,
        appointmentStart: this.time.start,
        appointmentEnd: (parseInt(this.time.start) + 1).toString(),
        outpatientId: this.city.id,
        userName: this.liaison.userName,
        userPhone: this.liaison.userPhone,
        mail: this.liaison.mail,
        sex: this.liaison.sex,
        fbqEventId: this.fbqEventId,
        comeFrom: localStorage.getItem("comeFrom"),
      };
      console.log(uresData);
      //预约请求
      confirmAppointmentClinic(uresData).then((res) => {    
          this.$router.push("/complete");
      });
    },
  },
};
</script>
<style scoped>
.container-xl {
  padding: 0;
}
.row {
  margin: 0;
  background-color: #f2f2f2;
}
.hade {
  width: 100%;
  padding: 10px 0;
  margin-top: 50px;
  background: linear-gradient(90deg, #36ff94 0%, #00e467 100%);
}
.hade > a {
  margin-left: 20px;
  font-weight: 700;
  display: flex;
  font-size: 19px;
}
.hade > a > img {
  width: 17px;
  height: 27px;
}

.time {
  border-bottom: 1px solid #cccccc;
  padding: 25px 20px 15px 20px;
}
.time > h3 {
  font-size: 1.4rem;
  font-weight: 700;
  margin-bottom: 25px;
}
.time > h5 {
  display: flex;
  align-items: center;
  font-size: 1rem;
  margin-bottom: 10px;
  color: #a0a0a0;
}
.clinic {
  border-bottom: 1px solid #cccccc;
  padding: 25px 20px 15px 20px;
}
.clinic > h4 {
  font-size: 1rem;
  font-weight: 600;
}
.clinic > p {
  margin-bottom: 5px;
  color: #a0a0a0;
  font-size: 0.95rem;
}
.data {
  padding: 25px 20px 30px 20px;
}
.data > h5 {
  display: flex;
  align-items: center;
  font-size: 1rem;
  margin-bottom: 10px;
  color: #a0a0a0;
}
.data > p {
  margin-top: 40px;
  color: #676767;
  line-height: 20px;
}
.data > h3 {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 40px;
}
.botttom {
  text-align: center;
}
.botttom > button {
  width: 30%;
  padding: 12px 0 12px 0;
  border: none;
  font-size: 19px;
  font-weight: 700;
  background: #00e467;
  margin-bottom: 100px;
  border-radius: 0px 10px 0px 0px;
}

h1,
h2,
h3,
h4,
h5,
button,
a {
  font-family: "chinaGenSenMaruGothicTW-Bold";
}

p,
span,
div {
  font-family: "chinaGenSenMaruGothicTW-Regular";
}
@media all and (max-width: 992px) {
  .hade {
    margin-top: 0px;
  }
  .botttom > button {
    width: 60%;
  }
  .row {
    background-color: #ffffff;
  }
}
@media all and (max-width: 570px) {
  .hade > a > img {
    width: 14px;
    height: 26px;
  }
  .hade > a {
    font-size: 18px;
  }
  .botttom > button {
    font-size: 16px;
  }
}
</style>